<app-organizer-shared-layout-list
  [title]="
    'organizer.timeslot.participant.manage.title'
      | translate: { total_attendee: bookingItemGroupByUserId.totalAttendees }
  "
  [backLink]="backlink | localize"
>
  <ng-container header-extra>
    <p class="font-bold text-vtmn-play-content-brand mt-3 -mb-3">
      {{
        bookingItemGroupByUserId.totalPrice
          | displayPrice: bookingItemGroupByUserId.bookingItems[0]?.currency
      }}
    </p>
  </ng-container>

  <section>
    <h4 class="title-4 lg:text-base">
      {{ 'organizer.timeslot.participant.manage.actions.title' | translate }}
    </h4>

    <button
      app-vtmn-play-button
      type="button"
      cta
      [type]="ctaButtonType.Button"
      [shape]="vtmnPlayButtonShape.SQUARED"
      class="mt-5"
      (click)="contact()"
    >
      {{
        'organizer.timeslot.participant.manage.actions.send_message' | translate
      }}
    </button>
  </section>
</app-organizer-shared-layout-list>
